import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LegalComponent } from './legal/legal.component';
import {RouterModule} from "@angular/router";
import { PrivacyComponent } from './privacy/privacy.component';
import { HomeComponent } from './home/home.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes = [
    {path:'**',component:HomeComponent},
    // {path:'legal',component:LegalComponent},
    // {path:'privacy',component:PrivacyComponent},
];

@NgModule({
  declarations: [
    AppComponent,
    LegalComponent,
    PrivacyComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule.forRoot(routes, /*{ useHash: true }*/),
  ],
  providers: [
      /*{
          provide: LocationStrategy,
          useClass: HashLocationStrategy
      }*/
],
  bootstrap: [AppComponent]
})
export class AppModule { }
